import React from 'react'
import { observer } from 'mobx-react-lite'
import { CheckBox, CheckBoxOutlineBlank } from '@mui/icons-material'

import { color } from '@trivie/ui-mobile/theme/color'
import { Text } from '@trivie/ui-mobile/components/text'
import { Button } from '@trivie/ui-web/components/button'
import { ChoiceAvatar } from './ChoiceAvatar'
import { useStores } from '@trivie/core'

import { useMediaQuery } from '@mui/material'
import { GameQuestion } from '@trivie/core/src/models/game/GameQuestion'
import { Instance } from 'mobx-state-tree'
import { GameChoice } from '@trivie/core/src/models/game/GameChoice'

interface ChoiceProps {
  question: Instance<typeof GameQuestion>
  choice: Instance<typeof GameChoice>
  backgroundColor: string
  textColor: string
  borderColor: string
  dataSet?: any
  /** Whether this choice should render its filled/emphasized state. */
  highlighted?: boolean
  mode?: 'quiz' | 'survey'
}
export const Choice = observer((props: ChoiceProps) => {
  const { userStore } = useStores()
  const { user } = userStore
  const {
    question,
    choice,
    backgroundColor,
    textColor,
    borderColor,
    dataSet,
    mode = 'quiz',
  } = props
  const { select, display, selected } = choice
  const { answer, answered } = question
  // Fill state is driven by selection in surveys, and by `answered` in quizzes.
  const highlighted =
    props.highlighted ?? (mode === 'survey' ? Boolean(selected) : Boolean(answered))

  const isMobile = !useMediaQuery('(min-width:800px)')

  const btnStyle = {
    borderColor,
    ...(highlighted && {
      backgroundColor,
    }),
    border: highlighted ? `2px solid ${backgroundColor}` : `2px solid ${borderColor}`,
    padding: 16,
    minHeight: 56,
    height: 'auto',
  }

  return (
    <Button
      sx={{ borderRadius: 6, justifyContent: question.MCA ? 'space-between' : 'center' }}
      data-qat={dataSet?.qat}
      key={choice.id.toString()}
      variant="outlined"
      fullWidth
      round
      size="large"
      style={btnStyle}
      disabled={answered}
      startIcon={
        question.MCA &&
        (selected ? (
          <CheckBox htmlColor={highlighted ? color.white : textColor} />
        ) : (
          <CheckBoxOutlineBlank htmlColor={highlighted ? color.white : textColor} />
        ))
      }
      endIcon={question.MCA ? <div style={{ width: 12 }} /> : null}
      onClick={() => {
        select()
        if (!question.MCA) {
          answer()
        }
      }}
    >
      <ChoiceAvatar
        show={Boolean(selected && answered && user)}
        photo={user?.photo_url || ''}
        name={`${user?.first_name} ${user?.last_name}`}
      />
      <Text
        disableLink
        variant="titleMedium"
        align="center"
        style={{ fontSize: isMobile ? 14 : 16, color: highlighted ? color.white : textColor }}
        text={display}
      />
    </Button>
  )
})
